import { useNavigate } from 'react-router-dom'
import styles from './DrawerBtnGroup.module.scss'
import React, { useEffect, useState } from 'react'


export interface ContentItem {

  title?: string
  Icon?: React.FC
  IconActive?: React.FC
  Content: React.FC,
  path?: string,
  reglexPah?: RegExp,
  HeaderComponent?: React.FC

}

export interface DrawerBtnProps {
  content: ContentItem[]
  modalStyles?: React.CSSProperties
  withNavigation?: boolean,
  basePath?: string
}

export default function DrawerBtnGroup({content , modalStyles, withNavigation, basePath}: DrawerBtnProps) {
  const [isOpenModal, setOpenModal] = useState(false)
  const [indexClicked, setIndexClicked] = useState(-1)
const navigate = useNavigate()

  useEffect(() => {
    if (withNavigation) {
      content.forEach((item, index) => {
        if (item.reglexPah && item.reglexPah.test(window.location.pathname)) {
          setIndexClicked(index)
          setOpenModal(true)
        }
      })
    }
    
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const handleClick = (index: number) => {
    setOpenModal(true)

    if(withNavigation) {
      const path = content[index].path
      path &&
      navigate(path)
      
    }else{
      setIndexClicked(index)
    }


    
    if (index === indexClicked) {
      setIndexClicked(-1)
      setOpenModal(!isOpenModal)

      if (withNavigation) {
        basePath &&
        navigate(basePath)
      }
    }


  }





  const getContentClick = () => {
    if (indexClicked === -1) {
      return null
    }
   const ContentCompo = content[indexClicked]?.Content



   return <ContentCompo />
  }




  const getTitle = () => content[indexClicked]?.title
  
  return (
    <div className={styles['global-container']}>
      <div className={styles['modal-container']}>
        <Modal title ={getTitle()} isOpen={isOpenModal}onClose={() => console.log('close')} HeaderComponent={content[indexClicked]?.HeaderComponent} >{ getContentClick()}</Modal>
      </div>
      <div className={styles['btn-container']}>
        {content.map((item, index) => {
          return(
            <div key={index} className={styles['btn-container__item']} >
            <ButtonItem   onClick={() => handleClick(index)} Icon={item.Icon} IconActive={item.IconActive} isActive={index === indexClicked} />
            </div>
          )
        })
          
        }
    
      </div>
    </div>
  )
}

export interface ButtonItemProps {
  iconName?: 'lamp'
  onClick?: () => void
  Icon?: React.FC
  IconActive ?: React.FC
  isActive?: boolean
}

const ButtonItem  = ({iconName, onClick, Icon, IconActive, isActive }: ButtonItemProps) => {

  return (
    <button onClick={onClick} className={[styles['button'], isActive ? styles['button--active'] : ""].join(" ")}>{!isActive ? (Icon && <Icon/> ):(IconActive ?  <IconActive /> : (Icon && <Icon/>))} </button>
  )
}

export interface ModalProps {
  onClose?: () => void
  children: React.ReactNode,
  isOpen?: boolean,
  title?: string,
  HeaderComponent?: React.FC
}

const Modal = ({children, isOpen, title, HeaderComponent}: ModalProps) => {
  const [isReadyToShow, setReadyToShow] = useState(false)


  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
      setReadyToShow(true)}, 300)
    } else {
      setTimeout(() => {
        setReadyToShow(false)}, 300)
 
    }
  },[isOpen])

  return (<div className={[styles['modal'], isOpen ? styles['modal--open']: styles['modal--close']].join(" ")}>
    <div className={styles['modal-content']}>
    { (title || HeaderComponent) &&
    <div className={styles['header-modal']}>
      <h2 className={styles['header-modal__title']}>{title}</h2>
      {HeaderComponent && <HeaderComponent />}  
    </div>
}
    <div className={styles['modal-body']} >
    {isReadyToShow && children}
    </div>
    </div>
  </div>)
}

